import { render, staticRenderFns } from "./FeaturesList.vue?vue&type=template&id=6ed1ce84"
import script from "./FeaturesList.vue?vue&type=script&lang=js"
export * from "./FeaturesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports